import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import ReactDOM from 'react-dom';
import BaseTable, {
    TableStore,
    connect,
    useAutoMerge,
    useStore,
    useResize,
    useIndex,
    useCheckbox,
    useSort,
    useExpandRow,
    useTreeTable,
    useFilter,
    usePagination,
    useErrorTips,
    useRowClick,
    useLocation,
    useContextMenu,
    useCellSelect,
    useHotKey,
    useDOM,
    useSimpleTable,
    useCache,
    useStyle,
    useGroupSort,
    useFieldSetting,
    useOprCol,
} from "@platform/table-core";
import { ViewModel, toast, getTopWindow } from '@platform/api';
import { getAutoWrap } from '../../libs/useContextMenu';
import { getRowHeight, setAutoWrap, getRandom } from '../utils';
import { getMultiLang, getGlobalStorage } from '@platform/api';
import FlatButton from './components/FlatButton';
import classnames from 'classnames';
import HistoryRecord from './components/HistoryRecord';
import { Tooltip } from '@platform/base';
// import { toast } from 'platform/old/2005'; // 有可能导致依赖循环

let hookExtensions = [
    connect,
    useHotKey,
    useStore,
    useResize,
    useIndex,
    useCheckbox,
    useExpandRow,
    useRowClick,
    useTreeTable,
    useSort,
    useCellSelect,
    useDOM,
    useSimpleTable,
    usePagination,
    useCache,
    useFilter,
    useLocation,
    useContextMenu,
    useGroupSort,
    useFieldSetting,
    useStyle,
    // useCopy,
    useErrorTips,
    useAutoMerge,
    useOprCol,
];

const ComposedTable = hookExtensions.reduceRight((Table, HOC) => HOC(Table), BaseTable);

class SimpleTable extends Component {
    cached = false;
    constructor(props) {
        super(props);
        this.state = { emptyTableData: [], searchTipVisible: false };
        this.emptyDataQuickAnimation = true;
        this.isListened = false;
        window._simpleTableGlobalParams = { [props.id]: {} };
    }
    componentDidMount() {
        let { store } = this.props;

        store.setRef(this);

        getMultiLang({
            moduleId: "page_table",
            callback: json => {
                store.setLocale(json);
            },
        });

        this.initQuery();
        this.useCache();
    }

    componentWillReceiveProps(nextProps) {
        let { pageScope, transformHistoryCard = data => data } = this.props;
        let { getUserQueryHistory } = pageScope.search;
        let { relationQuery } = nextProps;

        if (relationQuery && !this.isListened) { //初始化进来，绑定查询事件，触发一次查询
            //监听查询区的查询按钮
            pageScope.search.addEventListener(relationQuery, 'clickSearchBtn', this.getHistoryData, true);
            this.isListened = true;
            getUserQueryHistory({ areacode: relationQuery }).then(data => {
                this.setState({ emptyTableData: transformHistoryCard(data) });
            });
        }
    }

    render() {
        let {
                showCheck,
                showIndex,
                pkname,
                high_selectable,
                handlePageInfoChange,
                extendRightMenu,
                dataSource,
                crossPageSelect,
                onRowClick,
                onRowDoubleClick,
                //  selectedChange, 
                //  onSelected, 
                //  onSelectedAll, 
                //  onBatchSelected, 
                tableModelConfirm,
                rowClassName,
                adaptionHeight = true,
                height,
                cancelCustomRightMenu = false,
                showWidthAndHeightConfig = true,
                hideRightMenu = false,
                extendRightMenuPlacement,
                alloweFilter: enableFilter = true,
                handleFilterCallBack,
                handleResetCallBack,
                sort,
                hiddenLeftItem,
                noColSetClass,
                colSetCallback,
                showTotal,
                //  setCellClass,
                showPagination,
                disableClickRowToSelect, //只有simpletable有这个参数
                fieldid,
                tableCustomerArea,
                id,
                store,
                pageScope,
                allowTotalRows,
                noTotalRows,
                noTotalCol,
                onTableCellClick,
                addBlankCol,
                setSelectedNum,
                columnWidthConfig = true,
                fixFooter,
                scrollContainer,
                // addAffixScroll: fixFooter,
                mergeCell,
                autoMergeCell,
                checkboxMergeInfo,
                indexMergeInfo,
                lazyload = true,
                virtualHead,
                onSort,
                onFind,
                renderEmptyText, //领域-空状态文本
                renderExtendZone, //领域-空状态扩展区域
                relationQuery, //查询区ID
                emptyShowQuery, //是否显示空状态
                historyCardLength = 4, //空状态历史卡片数量
                setHeadClass, //设置表头class
                emptySearchCallBack, //空状态历史记录查询给领域的回调
                changeTableType, //主子表切换时调用的回调
                hiddenDelRow,
                _runContext, //内部页签上下文参数
                defaultPageSize, //默认分页
                maxPageSize, //最大分页
                customSetting = {}, //个性化设置参数
                flatConfig = {}, //拉平表参数
                hiddenFieldSetting, // 筛选排序下拉箭头开关
                relationMetaId,
                onContextMenu,
                enterDirection = 'right',
                rowHeight,
            } = this.props,
            config = store.getConfig(),
            {
                setCellClass,
                selectedChange,
                onSelected,
                onSelectedAll,
                onBatchSelected,
                layoutMode,
                hiddenFlatButton,
            } = config,
            useVirtual = true;
        let { clearUserQueryHistory } = pageScope.search;

        // 拉平表的config覆盖主表的(暂定模板上配的覆盖)
        // if(this.isFlatMode(id, meta, pageScope)) {  
        //     hiddenIndex = flatConfig.hiddenIndex;
        //     emptyShowQuery = flatConfig.emptyShowQuery;
        // }

        if (hideRightMenu) {
            cancelCustomRightMenu = true;
        }

        let locale = store.getLocale();
        let isLoadedMeta = store.getMeta() || {};
        //初始化
        if (config.multipleRowCell === true && getAutoWrap(store, id, true) === undefined && Object.keys(isLoadedMeta)?.length !== 0) {
            setAutoWrap(store, id, config.multipleRowCell);
        }

        let ncc_automated = getGlobalStorage('localStorage', '_ncc_automated_');
        if (ncc_automated == '1') {
            // 自动化测试开关打开
            useVirtual = false;
        }

        let shareIds = [];
        if (store.getGridTableId()) { // 入参id是表格id，看看是不是卡片表格的
            shareIds.push(store.getGridTableId());
        }
        let fontClass = window?.nccFontSize || (window && getTopWindow()?.nccFontSize) || getGlobalStorage('localStorage', 'nccFontSize') || '';
        let currentId = store.getFlatInfo()?.tableId || id;
        return <ComposedTable
            key={id}
            currentId={currentId}
            id={id}
            store={store}
            pageScope={pageScope}
            fixFooter={fixFooter}
            scrollContainer={scrollContainer}
            autoRowHeight={getAutoWrap(store, currentId)}
            bodyStyle={{
                height: height || 300,
                minHeight: 60,
            }}
            addBlankCol={addBlankCol}
            flex={adaptionHeight}
            rowHeight={rowHeight || getRowHeight(28, customSetting.tableType)}
            className="simple-table"
            defaultRenderStatus='browse'
            alwaysBrowse // switch_browse不显示组件，显示文字
            renderItems={pageScope.state.renderItem?.table?.[id] || {}}
            rowKey={row => row.key}
            allowTotalRows={allowTotalRows}
            noTotalRows={noTotalRows}
            noTotalCol={noTotalCol}
            virtualConfig={{ x: useVirtual, y: !!lazyload, header: virtualHead }}
            simpleTableConfig={{
                enable: true,
                tableModelConfirm,
            }}
            setHeadClass={setHeadClass}
            changeTableType={changeTableType}
            indexConfig={{ enable: showIndex, mergeInfo: indexMergeInfo }}
            relationMetaId={relationMetaId}
            checkboxConfig={{
                enable: showCheck,
                more: crossPageSelect && pkname,
                setSelectedNum,
                mergeInfo: checkboxMergeInfo,
                onCheck: (rowKey, { isChecked, checkedKeys, lastCheckedKeys }) => {
                    shareIds.forEach(shareId => {
                        pageScope.tableDataSource[shareId].setCheckedKeys(checkedKeys);
                    });
                    if (rowKey) {
                        let row = store.getRowData(rowKey);
                        if (isChecked) {
                            store.setClickedRow(rowKey);
                        } else {
                            store.setClickedRow('');
                        }

                        onSelected?.call(
                            pageScope,
                            { ...pageScope.props, ...pageScope.output },
                            id,
                            store.getInstance()._formatOutputRow(row),
                            row.dataIndex,
                            isChecked,
                        );
                    } else {
                        let visibleRowKeys = store.getVisibleRowKeys();
                        onSelectedAll?.call(
                            pageScope,
                            { ...pageScope.props, ...pageScope.output },
                            id,
                            !!checkedKeys.size, // checkedAll
                            visibleRowKeys.length,
                        );
                    }
                    selectedChange?.call(
                        pageScope,
                        { ...pageScope.props, ...pageScope.output },
                        id,
                        checkedKeys.size,
                        lastCheckedKeys.size,
                    );
                },
            }}
            cellSelectConfig={{
                enable: high_selectable?.enable ?? true,
                batchSelectEnable: false,
                onSelect: (selectedCell, { startCell, endCell, batchSelect, action }) => {
                    console.log('框选', selectedCell);

                    if (!startCell || !endCell || batchSelect) {
                        return;
                    }

                    if (onBatchSelected) {
                        /**
                        * 传了这个参数，才勾选前面的行。以前的逻辑是这样的
                        * 如果选中的是单行，走onRowClick逻辑
                        * 否则这里设置选中
                        */
                        let selectedRows = store.getCheckedKeys();
                        store.setCheckedKeys(new Set([...selectedCell.keys()].concat(action === "ctrl" ? [...selectedRows] : [])));
                        // endCell?.row?.key && startCell.row.key !== endCell.row.key && store.setCheckedKeys(new Set([...selectedCell.keys()]));
                        // 单行onRowClick走不到这里，cellSelect那里已经阻断了
                        onBatchSelected(
                            {
                                ...pageScope.props,
                                ...pageScope.output,
                            },
                            id,
                            [...selectedCell].map(([rowKey]) => store.getRowData(rowKey)),
                        );
                    }
                },
            }}
            rowProps={row => ({
                disableClickRowToSelect,
                disableClickCellToSelectProps: [{ className: 'code-detail-link' }],
                onClick: event => {
                    return onRowClick?.call(
                        pageScope,
                        { ...pageScope.props, ...pageScope.output },
                        id,
                        store.getInstance()._formatOutputRow(row),
                        row.dataIndex,
                        event,
                    );
                },
                onDoubleClick: onRowDoubleClick && (event => {
                    return onRowDoubleClick?.call(
                        pageScope,
                        store.getInstance()._formatOutputRow(row),
                        row.dataIndex,
                        { ...pageScope.props, ...pageScope.output },
                        event,
                    );
                }),
                className: typeof rowClassName === 'function' ?
                    rowClassName(store.getInstance()._formatOutputRow(row), row.dataIndex) :
                    rowClassName,
            })}
            paginationConfig={{
                enable: showPagination ?? pageScope.state.meta?.[id]?.pagination,
                defaultPageSize: defaultPageSize,
                maxPageSize: maxPageSize,
                paginationExtendRender: config.paginationExtendRender,
                onChange: ({ pageIndex, pageSize }) => {
                    let { allpks, allbodypks } = store.getAllRowsInfo(),
                        isFlat = store.isFlatStatus();

                    allpks = isFlat ? allbodypks : allpks;

                    if (!allpks?.length) { return; }

                    handlePageInfoChange?.(
                        { ...pageScope.props, ...pageScope.output },
                        config,
                        allpks.slice(pageIndex * pageSize, (pageIndex + 1) * pageSize),
                        allpks.length,
                    );
                },
            }}
            totalConfig={{ enable: showTotal }}
            fieldSettingConfig={{ enable: !hiddenFieldSetting }}
            filterConfig={{
                enable: enableFilter,
                title: pageScope.state.meta?.[currentId]?.name || '',
                onFilter: () => {
                    handleFilterCallBack?.(store.getVisibleRows());
                },
                onReset: () => {
                    handleResetCallBack?.(store.getVisibleRows());
                },
            }}
            sortConfig={{
                enable: true,
                // onSort: orderMap => {
                //     let sortInfo = [...orderMap].map(([colKey, order], index) => {
                //         return {
                //             order: order === 1 ? "ascend" : "descend",
                //             field: colKey,
                //             orderNum: index, 
                //         };
                //     });
                // sort?.sortFun?.(sortInfo);
                // },
                onSort: () => {
                    onSort?.(store.getVisibleRows());
                },
            }}
            locationConfig={{
                enable: true,
                onFind: (index, rowKey, colKey) => {
                    onFind?.(rowKey, colKey);
                },
            }}
            dataSource={dataSource}
            pkname={pkname}
            crossPageSelect={crossPageSelect}
            contextMenuConfig={{
                enable: !hideRightMenu && (high_selectable?.enable ?? true) && (high_selectable?.selectCell ?? true),
                hiddenDelRow,
                extendRightMenu,
                extendRightMenuPlacement, // 原代码的simpleTable没有这个值
                showRowMenu: false,
                cancelCustomRightMenu,
                showWidthAndHeightConfig,
                hiddenLeftItem,
                columnWidthConfig,
                disableArea: (rowKey, colKey) => {
                    if (!noColSetClass) { return false; }
                    let cellClass = store.getCellProps(rowKey, colKey, 'className');
                    return cellClass?.includes(noColSetClass);
                },
                onColSetting: () => {
                    colSetCallback?.();
                },
                onClick: key => {
                    pageScope.forceUpdate();
                    store.forceUpdate();
                    onContextMenu?.(key);
                },
            }}
            cellProps={(rowInfo, colInfo) => {
                let props = {};
                if (typeof onTableCellClick === 'function') {
                    props.onClick = e => {
                        onTableCellClick(rowInfo.row, rowInfo.rowIndex/** viewIndex */, colInfo.col.key, colInfo.col, e); //TODO 传给业务的可能需要转成dataIndex
                    };
                }
                if (typeof setCellClass === 'function') {
                    props.className = setCellClass(rowInfo.rowIndex/** viewIndex */, store.getInstance()._formatOutputRow(rowInfo.row), colInfo.col.key);
                }
                return props;
            }}
            renderEmptyArea={(wrapperHeight = 550) => { //渲染表格空状态
                if (!emptyShowQuery) {
                    return;
                }
                let { search } = this.props.pageScope;
                let { executeSearch } = search;
                let emptyTableData = this.state.emptyTableData.slice(0, historyCardLength);
                let isEmptyData = !emptyTableData?.length;
                let containerClass = '';
                let height = 520;
                let hasExtendZone = typeof renderExtendZone === "function";
                // 空状态布局
                if (wrapperHeight >= 550) {
                    height = 520;
                } else if (wrapperHeight >= 430 && wrapperHeight < 550) {
                    height = 420;
                } else if (wrapperHeight >= 390 && wrapperHeight < 430) {
                    height = '95%';
                    containerClass = 'empty-table-three';
                } else if (wrapperHeight >= 300 && wrapperHeight < 390) {
                    height = '95%';
                    containerClass = 'empty-table-four';
                } else if (wrapperHeight >= 220 && wrapperHeight < 300) {
                    containerClass = 'empty-table-five';
                    height = '95%';
                } else {
                    containerClass = 'empty-table-five';
                    height = 205;
                }

                return <div
                    className={classnames(
                        {
                            "empty-table-container": true,
                            [containerClass]: true,
                            'has-extend-zone': hasExtendZone,
                        },
                    )}
                    style={{ height: height }}
                >
                    <div className='empty-wrapper-top'>
                        <div className='top-left'>
                            <div className='top-left-background' ></div>
                        </div>
                        <div className='top-right'>
                            <div className='empty-text' fieldid='empty-table-text'>
                                {renderEmptyText?.() || locale['table0054'] /*暂无数据*/}
                            </div>
                            <div className={classnames('empty-extend-zone')}>
                                {renderExtendZone?.()}
                            </div>
                        </div>
                    </div>
                    <div className={classnames({
                        'history-quick-animation': this.emptyDataQuickAnimation,
                        'empty-wrapper-bottom': true,
                        'empty-wrapper-bottom-show': !isEmptyData,
                    },
                    )}>
                        <div className='recent-search-title'>
                            <span className="hr hr-left"></span>
                            <p>{locale['table_recent_search']/*记录近期使用过的查询结果*/}</p>
                            <Tooltip placement="top"
                                overlay={locale['table_clear_search']}
                                visible={this.state.searchTipVisible}
                            >
                                <i
                                    className={`iconfont icon-qingkongnew clear ${isEmptyData ? 'disable-clear' : ''}`}
                                    onClick={() => {
                                        if (isEmptyData) { //没有历史记录时
                                            return;
                                        }
                                        clearUserQueryHistory({ areacode: relationQuery }).then(() => {
                                            this.emptyDataQuickAnimation = false;
                                            this.setState({ emptyTableData: [] });
                                            toast({ content: locale['table_clear_success']/*清除历史记录成功*/, color: 'success' });
                                        }).catch(() => {
                                            toast({ content: locale['table_clear_warning']/*清除历史记录失败*/, color: 'warning' });
                                        });
                                    }}
                                    onMouseEnter={() => this.setState({ searchTipVisible: true })}
                                    onMouseOut={() => this.setState({ searchTipVisible: false })}
                                ></i>
                            </Tooltip>
                            <span className="hr hr-right"></span>

                        </div>
                        <div className='history-card-wrapper'>
                            {
                                emptyTableData.map(query => {
                                    let { querycondition = {}, recordtime, searchFlag, queryrelationinfo, pk_queryhistory } = query;
                                    let { conditions = [] } = querycondition;
                                    return <HistoryRecord
                                        key={pk_queryhistory}
                                        records={conditions}
                                        emptySearchCallBack={emptySearchCallBack}
                                        wrapperWidth={ReactDOM?.findDOMNode(this)?.querySelector('.history-card-wrapper')?.clientWidth}
                                        cardLength={emptyTableData.length}
                                        searchTime={recordtime}
                                        isDisabled={!searchFlag}
                                        queryrelationinfo={queryrelationinfo}
                                        locale={locale}
                                        onSearch={() => executeSearch(relationQuery, query)}
                                    />;
                                })
                            }
                        </div>
                    </div>
                </div>;
            }}
            renderFlatButton={() => {
                return !hiddenFlatButton && layoutMode === "flat" &&
                    <div className='flat-button-inner'>
                        <FlatButton
                            store={store}
                            moduleId={id}
                        />
                    </div>;
            }
            }
            isInnerFlatButton={!hiddenFlatButton && layoutMode == "flat"} //使用了内置的拉平切换按钮
            layoutMode={layoutMode}
            fieldid={fieldid}
            footer={tableCustomerArea}
            mergeCell={!!mergeCell || autoMergeCell}
            autoMergeCell={autoMergeCell}
            fontClass={fontClass}
            _runContext={_runContext}
            customSetting={customSetting}
            flatConfig={flatConfig}
            hotkeyConfig={{ enterDirection }}
        />;
    }

    componentDidUpdate() {
        this.useCache();
        let { pageScope, transformHistoryCard = data => data, store, relationQuery, id } = this.props;
        let { getUserQueryHistory } = pageScope.search;
        let visibleRows = store.getVisibleRows();

        let { setDataFlag, searchRecordFlag } = window._simpleTableGlobalParams?.[id] || {};
        if (relationQuery && searchRecordFlag && setDataFlag && !visibleRows.length) { //只有查不出数据时才请求接口  
            getUserQueryHistory({ areacode: relationQuery }).then(data => {
                this.setState({ emptyTableData: transformHistoryCard(data) });
            });
            window._simpleTableGlobalParams[id].searchRecordFlag = false;
            window._simpleTableGlobalParams[id].setDataFlag = false;
        }

    }

    componentWillUnmount() {
        let { dataSource, store, pkname, pageScope, relationQuery, _runContext = {} } = this.props;
        if (dataSource) {
            let pageInfo = store.getPaginationInfo(),
                rows = store.getRows() || [], // 这里不要去取缓存，之前出现过的卡片返回列表这里走卸载是因为领域写的有问题（代码里变有条件判断，各走了一次createSimpleTable，自然会卸载一个，最终结果是保留一个）// NCC-346084
                { allpks, alltss, allbodypks, pkrelation } = store.getAllRowsInfo(),
                filterInfo = store.getFilterInfo(),
                checkedInfo = store.getCheckedInfo(),
                sortInfo = store.getSortInfo(),
                lastClickedRow = store.getClickedRow(),
                visibleRows = store.getVisibleRows(),
                visibleLeafColumns = store.getVisibleLeafColumns(),
                flatInfo = store.getFlatInfo(),
                flatRelation = store.getFlatRelation(),
                { flatChildTableId, childPkName } = store.getConfig(),
                currentpks = visibleRows.map(row => row.values[pkname]?.value).filter(e => e),
                currentallpks = rows.map(row => row.values[pkname]?.value).filter(e => e), //包括过滤掉的
                currentbodypks = visibleRows.map(row => row.values[childPkName]?.value)?.filter(e => e),
                currenttss = visibleRows.map(row => row.values['ts']?.value).filter(e => e),
                { pageIndex, pageSize } = pageInfo;

            allpks = allpks ? [...allpks] : [];
            alltss = alltss ? [...alltss] : [];

            let cacheAllPks = [...allpks];
            let cacheAllBodyPks = [...allbodypks];
            if (flatInfo.tableType === "flat") {
                let startPkIndex, endPkIndex;
                allpks.forEach((pk, index) => {
                    if (currentallpks.includes(pk)) {
                        if (startPkIndex === undefined) {
                            startPkIndex = index;
                        }
                        endPkIndex = index;
                    }
                });
                allpks.splice(startPkIndex, endPkIndex - startPkIndex + 1, ...Array.from(new Set(currentpks))); //卡片翻页用
                allbodypks.splice(Number(pageIndex) * Number(pageSize), pageSize, ...currentbodypks);
            } else {
                allpks.splice(Number(pageIndex) * Number(pageSize), pageSize, ...currentpks);
            }
            alltss.splice(Number(pageIndex) * Number(pageSize), pageSize, ...currenttss);

            // 附件列
            let attachmentCols = [];
            visibleLeafColumns.forEach(col => {
                if (col.itemtype === "attachment") {
                    attachmentCols.push(col);
                }
            });

            let data = {
                simpleTable: {
                    rows: rows,
                    currentpks, // 当页的pk
                    allpks,
                    alltss,
                    cacheAllBodyPks,
                    cacheAllPks,
                    pageInfo,
                    scrollTop: findDOMNode(this).querySelector('.vertical-scroll-bar').scrollTop,
                    checkedInfo,
                    filterInfo,
                    sortInfo,
                    pkname,
                    childPkName: childPkName,
                    lastClickedRow,
                    flatInfo,
                    flatChildTableId,
                    flatRelation,
                    attachmentCols,
                    pkrelation,
                },
            };

            ViewModel.setData(dataSource, data, _runContext);
        }
        this.isListened && pageScope.search.removeEventListener(relationQuery, 'clickSearchBtn', this.getHistoryData.callbackId);
        this.isListened = false;
        this.props.store.removeRef(this);
    }

    useCache = () => {
        let { dataSource, store, _runContext = {}, id, layoutMode, pageScope } = this.props,
            columns = store.getColumns(),
            meta = store.getMeta(),
            { componentInitFinished, flatChildTableId, childPkName, pkname, onRowClick } = store.getConfig() || {};
        if (dataSource && !this.cached && columns.length && meta) {
            this.cached = true;

            let cache = ViewModel.getData(dataSource, _runContext)?.simpleTable;

            if (!cache) { return; }

            // cache里没有flatInfo时（比如单据追溯返回列表），从store里取 YBP-FI-BUG-9088
            let isFlat = cache.flatInfo ? cache?.flatInfo.tableType === 'flat' : store.isFlatStatus(); // YBP-FI-BUG-8384

            // 主表模式已经在cacheApi里处理了，这里只处理拉平的情况，把主表数据拉平
            if (isFlat) {
                let { pkrelation = {}, pageInfo = {} } = cache, // 主表和子表的关系
                    visibleLeafColumns = store.getVisibleLeafColumns(),
                    headKeys = visibleLeafColumns.filter(e => !e.isChildCol).map(e => e.attrcode);

                let body2head = Object.entries(pkrelation).reduce((res, [head, bodys]) => {
                    bodys.forEach(body => {
                        res[body] = head;
                    });
                    return res;
                }, {});

                // next是addCache和updateCache传入的数据，当时只处理了主表，在这里判断是否需要拉平处理
                cache.next?.forEach(({ bodys, head, pkvalue, type }) => {
                    let bodyRows = bodys?.[flatChildTableId]?.rows ?? [],
                        bodyPks = [];

                    // 生成拉平数据
                    let flatRows = bodyRows.map(bodyRow => {
                        // 主表字段 + 子表字段，优先取子表
                        let values = { ...head.values, ...bodyRow.values };

                        // 主表字段取主表值
                        headKeys.forEach(key => {
                            head.values[key] && (values[key] = head.values[key]);
                        });

                        values.ts = head.values.ts; // ts取主表
                        values.hts = head.values.ts; // 供应链逻辑

                        bodyPks.push(bodyRow.values[childPkName].value);

                        return { values, rowId: getRandom() };
                    });

                    if (type === 'update') {
                        /**
                         * - 仅修改rows和cacheAllBodyPks
                         * - rows根据flatRows增删改（子表的增删改）
                         * - allbodypks增删（子表的增删）
                         */

                        /**
                         * 对比rows和flatRows，对rows进行新增/修改/删除
                         */
                        let nextRows = [], // 更新 && 去掉删除行
                            addedRows = []; // 新增的行

                        // 1、遍历列表缓存数据，找到需要修改的数据，过滤删除的数据
                        cache.rows.forEach(row => {
                            // 没有子表主键，认为是updateCache添加的默认数据，删掉
                            if (!row.values[childPkName]?.value) {
                                return;
                            }

                            // 是与当前传入的主表相关联的子表
                            if (row.values?.[pkname]?.value === pkvalue) {
                                // 需要判断是更新还是删除
                                let matchedRow = flatRows.find(flatRow => flatRow.values[childPkName].value === row.values[childPkName].value); // 列表中的数据和拉平卡片的数据匹配

                                if (matchedRow) {
                                    // 匹配到，要更新缓存中list的数据 
                                    nextRows.push(
                                        {
                                            ...row,
                                            values: {
                                                ...row.values,
                                                ...matchedRow.values,
                                            },
                                        },
                                    );
                                }
                                // else {
                                //     // 匹配不到，说明删除了
                                // }
                            } else {
                                // 与当前传入的主表无关联的子表
                                nextRows.push(row);
                            }
                        });

                        // 2、遍历拉平数据，找到新增的数据
                        flatRows.forEach(flatRow => {
                            let childPk = flatRow.values[childPkName].value;

                            if (!cache.cacheAllBodyPks.includes(childPk)) {
                                //无对应的子表pk，是新增行
                                addedRows.push({
                                    rowId: getRandom(),
                                    values: flatRow.values,
                                });
                            }
                        });

                        // 新增行插入到末尾
                        cache.rows = nextRows.concat(addedRows);

                        // 更新cacheAllBodyPks
                        let deletePks = [];

                        if (pkrelation[pkvalue]) {
                            deletePks = pkrelation[pkvalue];
                        } else {
                            // 没缓存时一定只有一页
                            cache.rows.forEach(row => {
                                if (row.values[pkname]?.value === pkvalue) {
                                    deletePks.push(row.values[childPkName]?.value);
                                }
                            });
                        }

                        // cacheAllBodyPks是连续的
                        let index = cache.cacheAllBodyPks.findIndex(bodypk => deletePks[0] === bodypk);
                        let delCount = deletePks.length; //要删除的子表的pk数量
                        cache.cacheAllBodyPks.splice(index, delCount, ...bodyPks);
                    } else if (type === 'add') {
                        /**
                         * - pkvalue插入到allpks当页最后一条数据所在主表的后面
                         * - pkvalue插入到currentpks最后
                         * - bodypks插入到allbodypks当页最后一条数据所在主表的后面
                         * - flatRows插入rows后面
                         */

                        // 新增时先把当前行过滤掉，这些是在addCache时加的，位置是错的（因为算index时没算子表）
                        cache.allpks = cache.allpks.filter(e => e !== pkvalue);
                        cache.cacheAllPks = cache.cacheAllPks.filter(e => e !== pkvalue);
                        cache.currentpks = cache.currentpks.filter(e => e !== pkvalue);
                        // cache.alltss = cache.alltss = alltss.filter(e => e !== head.values.ts?.value);
                        cache.rows = cache.rows.filter(e => e.values[pkname].value !== pkvalue);

                        let { pageIndex = 0, pageSize = 100 } = pageInfo,
                            insertHeadIndex = 0, // 主表pk插入位置
                            insertBodyIndex = 0, // 子表pk插入位置
                            lastRow = cache.rows[cache.rows.length - 1],
                            lastBodyIndex = Number(pageSize) * Number(pageIndex) + Number(cache.rows.length - 1),
                            lastBodyPk = cache.cacheAllBodyPks[lastBodyIndex], // 当前页的最后一条pk。lastBodyPk可能在当前页，也可能在上一页（当前页为空）
                            headPk;

                        // 找到当前页最后一条pk所对应的主表，新数据要插入到这条数据后面
                        if (body2head[lastBodyPk]) {
                            // 有缓存。
                            headPk = body2head[lastBodyPk];
                        } else if (lastBodyPk) {
                            // 没有body2head说明没缓存，一定是在当前页
                            headPk = lastRow.values[pkname].value;
                        } else {
                            // 没缓存且当前页没数据
                            headPk = null;
                        }

                        if (headPk) {
                            insertHeadIndex = cache.allpks.findIndex(pk => pk === headPk) + 1;
                            // 找当前head的最后一个bodypk的位置
                            if (pkrelation[headPk]) {
                                let lastBodyPk = pkrelation[headPk][pkrelation[headPk].length - 1];
                                insertBodyIndex = cache.cacheAllBodyPks.findIndex(e => e === lastBodyPk) + 1;
                            } else {
                                // 没缓存的时候一定只有一页，插入到最后即可
                                insertBodyIndex = Infinity;
                            }
                        } else {
                            insertHeadIndex = 0;
                            insertBodyIndex = 0;
                        }

                        // 更新
                        cache.allpks.splice(insertHeadIndex, 0, pkvalue);
                        cache.cacheAllPks.splice(insertHeadIndex, 0, pkvalue);
                        cache.currentpks.splice(cache.currentpks.length, 0, pkvalue);
                        cache.cacheAllBodyPks.splice(insertBodyIndex, 0, ...bodyPks);
                        cache.rows.push(...flatRows);
                    } else if (type === 'delete') {
                        /**
                         * cacheAllBodyPks里把pkvalue相关的删除
                         */
                        let deleteBodyPkSet = new Set();

                        cache.rows = cache.rows.filter(row => {
                            if (row.values[pkname]?.value === pkvalue) {
                                deleteBodyPkSet.add(row.values[childPkName]?.value);
                                return false;
                            }
                            return true;
                        });

                        if (pkrelation[pkvalue]) {
                            deleteBodyPkSet = new Set([...deleteBodyPkSet, ...pkrelation[pkvalue]]);
                        }

                        cache.cacheAllBodyPks = cache.cacheAllBodyPks.filter(e => !deleteBodyPkSet.has(e));
                    }

                    // 更新主子关联关系
                    pkrelation[pkvalue] = bodyPks;
                });

                cache.next = [];
                cache.pkrelation = pkrelation;
            } else {
                // TODO: 非主子拉平的情况，应该没啥需要特殊处理的，在cacheApi里都处理过了
            }

            if (cache.pageInfo) {
                store.setPaginationInfo(cache.pageInfo);
            }

            if (cache.rows) {
                store.setRows({ rows: cache.rows });
            }

            if (cache.cacheAllPks) {
                if (cache.alltss) {
                    store.setAllRowsInfo({ allpks: cache.cacheAllPks, alltss: cache.alltss });
                } else {
                    store.setAllRowsInfo({ allpks: cache.cacheAllPks });
                }
            }
            if (cache.cacheAllBodyPks) {
                store.setAllRowsInfo({ allbodypks: cache.cacheAllBodyPks });
            }

            if (cache.scrollTop && cache.rows.length) {
                setTimeout(() => {
                    this.scroll(cache.scrollTop);
                });
            }

            if (cache.checkedInfo) {
                store.setCheckedInfo(cache.checkedInfo);
            }

            if (cache.filterInfo) {
                store.setFilterInfo(cache.filterInfo);
            }

            if (cache.sortInfo) {
                store.setSortInfo(cache.sortInfo);
            }

            if (cache.flatInfo?.tableId) {
                store.setFlatInfo(cache.flatInfo, { local: false });
            }

            if (cache.pkrelation) {
                store.setAllRowsInfo({ pkrelation: cache.pkrelation });
            }

            if (cache.lastClickedRow) {
                let row = store.getRowData(cache.lastClickedRow);

                if (row) {
                    store.setClickedRow(cache.lastClickedRow);

                    if (layoutMode === "vertical") {
                        onRowClick?.call(
                            pageScope,
                            { ...pageScope.props, ...pageScope.output },
                            id,
                            store.getInstance()._formatOutputRow(row),
                            row.dataIndex,
                            {},
                        );
                    }
                } else {
                    delete cache.lastClickedRow;
                }
            }

            componentInitFinished?.();
        }
    }

    scroll = scrollTop => {
        requestAnimationFrame(() => {
            if (findDOMNode(this).querySelectorAll('.table-next-body tr:not(.empty-table)').length) {
                findDOMNode(this).querySelector('.vertical-scroll-bar').scrollTop = scrollTop;
            } else {
                this.scroll(scrollTop);
            }
        });
    }

    getHistoryData = () => {
        let { id } = this.props;
        this.emptyDataQuickAnimation = false;
        // //点击查询的时候，要先存数据，后取，此时代表可以取了
        if (window._simpleTableGlobalParams?.[id]) {
            window._simpleTableGlobalParams[id].searchRecordFlag = true;
        } else {
            window._simpleTableGlobalParams[id] = {};
            window._simpleTableGlobalParams[id].searchRecordFlag = true;
        }
    }

    initQuery = () => {
        let { pageScope, relationQuery, transformHistoryCard = data => data } = this.props;
        let { getUserQueryHistory } = pageScope.search;

        if (relationQuery && !this.isListened) {
            //监听查询区的查询按钮
            pageScope.search.addEventListener(relationQuery, 'clickSearchBtn', this.getHistoryData, true);
            this.isListened = true;
            getUserQueryHistory({ areacode: relationQuery }).then(data => {
                this.setState({ emptyTableData: transformHistoryCard(data) });
            });
        }
    }
}

SimpleTable.displayName = 'SimpleTable';
SimpleTable.useSimpleTable = function () {
    let store = new TableStore(hookExtensions);
    return store.getAllHooks();
};

export default SimpleTable;